import * as types from "../constants/actionTypes";

export const commonReducerInitialState = {
    hideBannerOnCrash: false,
    stayOnIncompleteForm: false
};

export default function commonReducer(state = commonReducerInitialState, action) {
    const type = action.type;

    if (typeof type === 'string') {
        if (type === types.STAY_ON_INCOMPLETE_FORM) {
            return { ...state, stayOnIncompleteForm: action.stay };
        }
        else if (type === types.USER_TO_SWITCH) {
            return { ...state, userToSwitch: action.user };
        }
        else if (type.indexOf('GET_APP_UPDATE') === 0) {
            if (action.success) {
                state[type] = { ...state[type], waiting: false, success: true, response: action.data, error: null };
            }
            else if (action.failure) {
                state[type] = { ...state[type], waiting: false, success: false, response: null, error: action.error };
            }
            else {
                state[type] = { waiting: true, request: action.data };
            }

            if (action.data !== undefined) {
                return { ...state, rxDown: action.data.rxDown, aalDown: action.data.aalDown, swhpDown: action.data.swhpDown, epicEHRDown: action.data.epicEHRDown };
            }
        }
        if (type === types.UPDATE_MENU) {
            return { ...state, currentLocation: action.currentLocation };
        }
        if (type === types.HIDE_BANNER_ON_CRASH) {
            return { ...state, hideBannerOnCrash: action.value };
        }
        if (type === types.COLLAPSE_MENU)
            return { ...state, showCollapsedMenu: action.showCollapsedMenu };
        if (type === types.SET_VIDEO_VISIT_TOASTR_MSG)
            return { ...state, videoVisitToastr: { message: action.message, successStatus: action.successStatus } };
    }

    return state;
}